import type { HttpClient } from '../client-app/index';
import type { IdentityProvider } from '../identity-provider';
import type { AuthLogger } from '../../shared/auth-logger';
import { DeleteAccountStep } from '../../constants';

export async function cognitoDeleteAccount(idp: IdentityProvider, http: HttpClient, logger?: AuthLogger): Promise<void> {
  logger?.log(DeleteAccountStep.Request);
  const idToken = await idp.getIdToken();
  await http.request('/services/api/v4/auth/account', 'DELETE', undefined, { Authorization: `Bearer ${idToken}` });
  await idp.deleteUser();
  logger?.log(DeleteAccountStep.Success);
}
